/**
 * Vistas del área central, POR REGISTRO — no por condicional.
 *
 * Antes la vista central se elegía con un condicional cableado (`admin` →
 * panel de administración, `ficheros` → explorador). Con dos mecanismos más ese
 * condicional es el sitio exacto donde el genérico se contamina: cada instancia
 * nueva obligaría a tocarlo. Aquí se registra una vez y el armazón resuelve por
 * id de ítem de menú.
 *
 * Los mecanismos entran como UNA sola entrada por prefijo (`mecanismo:*`),
 * resuelta por código: dar de alta el tercer mecanismo no toca este fichero.
 *
 * Importar este módulo es lo que puebla el registro; se hace una sola vez, en
 * el armazón.
 */

import InstalacionPanel from './components/InstalacionPanel.jsx'
import AuditoriaPanel from './components/AuditoriaPanel.jsx'
import DetencionesPanel from './components/DetencionesPanel.jsx'
import FileExplorer from './components/FileExplorer.jsx'
import SaberPanel from './components/SaberPanel.jsx'
import EstrategiaPanel from './components/EstrategiaPanel.jsx'
import MiEquipoPanel from './components/MiEquipoPanel.jsx'
import AgentesPanel from './components/AgentesPanel.jsx'
import PersonasPanel from './components/PersonasPanel.jsx'
import Perfil from './despacho/Perfil.jsx'
import NormasPanel from './components/NormasPanel.jsx'
import MechanismViewer from './mecanismos/MechanismViewer.jsx'
import { PESTANAS_ADMIN } from './lib/admin.js'
import { PREFIJO_MECANISMO, registrarVista, registrarVistaPorPrefijo } from './mecanismos/registro.js'

// GEN-PX-017: «Admin» del raíl = la instalación, con su submenú (Herramientas, Modelos, Marca y estilo, Coste, Salud). La gestión de
// usuarios ya no es de Admin: vive en Personas (que usa AdminPanel por dentro). Cada entrada del submenú se abre también por su id
// (ruta oculta del libro de estilo) y cae en la misma pantalla con su pestaña.
for (const id of ['admin', ...PESTANAS_ADMIN.map(p => p.id)]) registrarVista(id, InstalacionPanel)
// GEN-PX-014/022: «Personas» del raíl, para todos: el admin ve la gestión (invitar, cambiar rol) y el resto el directorio en solo lectura.
registrarVista('personas', PersonasPanel)
registrarVista('ficheros', FileExplorer)
// GEN-PX-016: «Auditoría» del raíl (pestañas Detenciones y Saber, las que mande el kernel). `detenciones` suelta es el respaldo con el kernel anterior (sin ítem `auditoria`): entonces es una entrada de Admin.
registrarVista('auditoria', AuditoriaPanel)
registrarVista('detenciones', DetencionesPanel)
// GEN-PX-022: «Agentes» del raíl, para todos: el admin ve la gestión (Mi equipo) y el resto sus agentes en solo lectura.
registrarVista('agentes', AgentesPanel)
// `equipo` (ítem solo-admin del kernel) abre la misma gestión que Agentes.
registrarVista('equipo', MiEquipoPanel)
// `agentes-permisos` (Perfiles) abre Agentes con esa entrada del carril.
registrarVista('agentes-permisos', AgentesPanel)
// GEN-EKB-018: zona «Saber» del raíl (cabecera con Jimmy y cifras). GEN-PX-021: absorbe KBs, Ámbitos y áreas y Pendiente de mí de «Mi empresa».
registrarVista('saber', SaberPanel)
// GEN-PX-018: «Estrategia» del raíl, para todos: cabecera presidida por Jorge, emitida por el kernel.
registrarVista('estrategia', EstrategiaPanel)
// GEN-PX-006: perfil del usuario (propio, o de otro empleado en solo lectura). Se abre desde el menú del avatar y desde las píldoras de «Tus empleados»; no es del menú del kernel.
registrarVista('perfil', Perfil)
// GEN-PX-015: «Normas» del raíl abre directamente el visor del mecanismo (pestañas si hay varios); `mecanismo:*` sigue resolviéndose con el mismo visor .
registrarVista('normas', NormasPanel)
registrarVistaPorPrefijo(PREFIJO_MECANISMO, MechanismViewer)
